import { render, staticRenderFns } from "./ProfitPaid.vue?vue&type=template&id=765faeee"
import script from "./ProfitPaid.vue?vue&type=script&lang=js"
export * from "./ProfitPaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports